import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { GetGlossaryTermNameResponse } from './getGlossaryTermName';

type GetGlossaryTermCategoryInfoParams = {
  category: string;
};

export const getGlossaryTermCategoryInfo = async ({ category }: GetGlossaryTermCategoryInfoParams) => {
  const { data } = await openMetadataApiClient.get<GetGlossaryTermNameResponse>(`/glossaries/name/${category}`, {
    params: {
      fields: 'owners,tags,reviewers,votes,domains,termCount',
    },
  });
  return data;
};
